import { useState } from "react";

const initialFormValue = {
  title: "",
  body: "",
  publish: true,
};

export const useAnnouncementForm = () => {
  const [form, setForm] = useState(initialFormValue);
  const [touched, setTouched] = useState(
    Object.keys(initialFormValue).reduce(
      (acc, key) => ({
        ...acc,
        [key]: false,
      }),
      {}
    )
  );

  const getErrors = (fieldValues = form, errors = {}) => {
    const newErrors = { ...errors };
    if ("title" in fieldValues)
      newErrors.title = fieldValues.title ? "" : "This field is required.";
    if ("body" in fieldValues)
      newErrors.body = fieldValues.body ? "" : "This field is required.";
    return newErrors;
  };

  const [errors, setErrors] = useState(() => getErrors(initialFormValue));

  const validate = (fieldValues = form) => {
    setErrors({
      ...getErrors(fieldValues, errors),
    });
  };

  const markAsTouched = (fieldName) => {
    setTouched({
      ...touched,
      [fieldName]: true,
    });
  };

  const markAllAsTouched = () => {
    setTouched(
      Object.keys(initialFormValue).reduce(
        (acc, key) => ({
          ...acc,
          [key]: true,
        }),
        {}
      )
    );
  };

  /**
   * Handles fields manipulation, setting new field values, errors, and marks as touched
   *
   * @param {string} fieldName
   * @param {string} fieldValue
   * @param {boolean} forceInvalidation When set to true it will forcefully invalidate the form field
   */
  const handleInputValue = (
    fieldName,
    fieldValue,
    forceInvalidation = false
  ) => {
    setForm({
      ...form,
      [fieldName]: fieldValue,
    });
    if (!forceInvalidation) validate({ [fieldName]: fieldValue });
    else forceInvalidate(fieldName);
    markAsTouched(fieldName);
  };

  const prefillForm = (newFormValue) => {
    const newValue = {
      title: newFormValue?.title ?? form.title,
      body: newFormValue?.body ?? form.body,
      publish: newFormValue?.publish ?? form.publish,
    };
    setForm(newValue);
    validate(newValue);
    markAllAsTouched();
  };

  const forceInvalidate = (fieldName) => {
    setErrors({
      ...errors,
      // Forced invalidation
      [fieldName]: "Invalid content",
    });
  };

  const formIsValid = () => Object.values(errors).every((err) => !err);

  return {
    form,
    errors,
    touched,
    prefillForm,
    handleInputValue,
    markAsTouched,
    markAllAsTouched,
    formIsValid,
  };
};
